import { create } from "zustand";
import { persist } from "zustand/middleware";

const AUTH_STORAGE_KEY = "upright-auth";

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  _hasHydrated: boolean;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearAuth: () => void;
  setHasHydrated: (value: boolean) => void;
}

/** Selector: true if user has valid token in store (or localStorage via persist) */
export const selectIsAuthenticated = (state: AuthState) => !!state.accessToken;

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      _hasHydrated: false,

      setTokens: (accessToken, refreshToken) => {
        set({ accessToken, refreshToken });
      },

      clearAuth: () => {
        set({ accessToken: null, refreshToken: null });
      },

      setHasHydrated: (value) => {
        set({ _hasHydrated: value });
      },
    }),
    {
      name: AUTH_STORAGE_KEY,
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
